import {AnyAction} from 'redux';
import { RESET_SNACKBAR, SET_SNACKBAR } from '@app/store/constants';
import { ISnackbarState } from '@app/models';

const initialSnackbarState = {
    snackbar: { show: false, message: '', severity: undefined} as ISnackbarState
};

export function snackbar(state = initialSnackbarState, action: AnyAction) {
    const {payload, type} = action;

    switch (type) {
        case RESET_SNACKBAR:
            return initialSnackbarState;

        case SET_SNACKBAR:
            return {
                ...state,
                snackbar: payload
            };

        default:
            return state;
    }
}
